import { RECONNECT_BASE_DELAY, RECONNECT_MAX_DELAY } from '../constants';

/** Widest spread the jitter can add to a backoff, in ms. */
export const RECONNECT_JITTER = 1000;

/** Exponential backoff before jitter; the inspector shows it as the low end of the wait. */
export const getReconnectBackoffBase = (attempt: number): number =>
  Math.min(RECONNECT_BASE_DELAY * Math.pow(2, attempt), RECONNECT_MAX_DELAY);

/**
 * Calculate the reconnect delay (ms) for a given attempt using exponential
 * backoff capped at {@link RECONNECT_MAX_DELAY}, plus 0–1s of jitter to avoid
 * thundering-herd reconnection.
 */
export const calculateReconnectDelay = (attempt: number): number =>
  getReconnectBackoffBase(attempt) + Math.random() * RECONNECT_JITTER;
